import _app from "../../../views/_app.tsx";
import _error from "../../../views/_error.tsx";

/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { viewManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
const manifest = {
  "_app": _app,
  "_error": _error,
  "archive-blog": dynamic(() => import("../../../views/archive-blog.tsx"), "views/archive-blog.tsx"),
  "archive-strand": dynamic(() => import("../../../views/archive-strand.tsx"), "views/archive-strand.tsx"),
  "page": dynamic(() => import("../../../views/page.tsx"), "views/page.tsx"),
  "program": dynamic(() => import("../../../views/program.tsx"), "views/program.tsx"),
  "search-results": dynamic(() => import("../../../views/search-results.tsx"), "views/search-results.tsx"),
  "shared-planner": dynamic(() => import("../../../views/shared-planner.tsx"), "views/shared-planner.tsx"),
  "single": dynamic(() => import("../../../views/single.tsx"), "views/single.tsx"),
  "single-blog": dynamic(() => import("../../../views/single-blog.tsx"), "views/single-blog.tsx"),
  "single-film": dynamic(() => import("../../../views/single-film.tsx"), "views/single-film.tsx"),
  "single-strand": dynamic(() => import("../../../views/single-strand.tsx"), "views/single-strand.tsx"),
  "single-tff-center": dynamic(() => import("../../../views/single-tff-center.tsx"), "views/single-tff-center.tsx"),
  "single-tff-center-tickets": dynamic(
    () => import("../../../views/single-tff-center-tickets.tsx"),
    "views/single-tff-center-tickets.tsx",
  ),
  "single-venue": dynamic(() => import("../../../views/single-venue.tsx"), "views/single-venue.tsx"),
  "story-sharer": dynamic(() => import("../../../views/story-sharer.tsx"), "views/story-sharer.tsx"),
  "template-browse-films": dynamic(
    () => import("../../../views/template-browse-films.tsx"),
    "views/template-browse-films.tsx",
  ),
  "template-film-finder": dynamic(
    () => import("../../../views/template-film-finder.tsx"),
    "views/template-film-finder.tsx",
  ),
  "template-home": dynamic(() => import("../../../views/template-home.tsx"), "views/template-home.tsx"),
  "template-landing-redirect": dynamic(
    () => import("../../../views/template-landing-redirect.tsx"),
    "views/template-landing-redirect.tsx",
  ),
};

viewManifestReader.set(manifest);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
